module.exports = __webpack_public_path__ + "img/vertical_6_6_5.396ef38f.png";